class ShippingCaculator extends HTMLElement {
	constructor() {
		super();

    this.needEndLoading = false;
    this.showingErrors = false;
    this.generatedShipping = 0;
		this.button = this.querySelector('button');
		this.addressCountrySelect = this.querySelector('#AddressCountryCalculator');
		this.addressProvinceSelect = this.querySelector('#AddressProvinceCalculator');
		this.addressCityInput = this.querySelector('#AddressCityCalculator');
		this.addressZipInput = this.querySelector('#AddressZipCalculator');
    this.resultsTag = this.querySelector('.shipping-calculator__results');
    this.resultsList = this.querySelector('.shipping-calculator__results-list');
    this.resultsErrorHeading = this.querySelector('.shipping-calculator__error-heading');
    this.resultsSuccessHeading = this.querySelector('.shipping-calculator__success-heading');

    // Comuna dependiente de la region (solo Chile). Ver snippets/shipping-calculator.liquid.
    this.cityField = this.querySelector('[data-city-field]');
    this.cityLabel = this.querySelector('[data-city-label]');
    this.comunaWrapper = this.querySelector('[data-comuna-wrapper]');
    this.comunaSelect = this.querySelector('#AddressComunaCalculator');
    // tercer nivel (15-09): ciudad o localidad de Starken dentro de la comuna elegida
    this.localidadField = this.querySelector('[data-localidad-field]');
    this.localidadSelect = this.querySelector('#AddressLocalidadCalculator');
    this.regionActual = null;
    this.regiones = null;
    this.comunasListas = false;

    this.button.addEventListener('click', this.onButtonClick.bind(this));
    this.addEventListener('change', this.hideErrorsTag.bind(this), false);

    this.onCartChangeHandler = this.onCartChange.bind(this);
    document.addEventListener('afterCartChanged', this.onCartChangeHandler);
    document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
	}

  connectedCallback() {
    this.setupCountries();
    this.setupComunas();
  }

  setupComunas() {
    if (!this.comunaSelect || this.comunasListas) return;
    this.comunasListas = true;
    // CountryProvinceSelector rehace las regiones en su propio 'change' del pais:
    // se espera un tick para leer la region ya actualizada
    this.addressCountrySelect.addEventListener('change', () => setTimeout(() => this.syncCityField(true), 0));
    this.addressProvinceSelect.addEventListener('change', () => this.syncCityField(true));
    this.comunaSelect.addEventListener('change', () => {
      this.addressCityInput.value = this.comunaSelect.value;
      this.comunaSelect.removeAttribute('aria-invalid');
      this.syncLocalidades('');
    });
    if (this.localidadSelect) {
      this.localidadSelect.addEventListener('change', () => {
        this.addressCityInput.value = this.localidadSelect.value || this.comunaSelect.value;
      });
    }
    setTimeout(() => this.syncCityField(false), 0);
  }

  // Starken cobra por localidad y Zipnova la respeta (Alto Jahuel no cuesta lo mismo que Buin), asi que a la
  // tarifa se manda la localidad si se eligio una. La comuna de cada localidad sale de OpenStreetMap
  // (recursos/localidades_comuna_osm.py); las que no se pudieron ubicar siguen en la lista de comunas.
  localidadesSinComuna(region) {
    if (!region) return [];
    return Array.isArray(region.localidades) ? region.localidades : (region.sin_comuna || []);
  }

  localidadesDe(region, comuna) {
    if (!region || !comuna || Array.isArray(region.localidades)) return [];
    return (region.localidades || {})[comuna] || [];
  }

  syncLocalidades(anterior) {
    const comuna = this.comunaSelect.value;
    const lista = this.localidadesDe(this.regionActual, comuna);
    if (!this.localidadField || !this.localidadSelect) return;
    this.localidadSelect.innerHTML = '';
    if (!lista.length) {
      this.localidadField.classList.add('hidden');
      this.addressCityInput.value = comuna;
      return;
    }
    // la primera opcion es la propia comuna: quien vive en el centro no tiene que buscar nada
    this.localidadSelect.add(new Option(comuna, comuna));
    lista.forEach((localidad) => {
      const o = new Option(localidad, localidad);
      if (anterior && this.normalizar(localidad) === anterior) o.selected = true;
      this.localidadSelect.add(o);
    });
    this.localidadField.classList.remove('hidden');
    this.addressCityInput.value = this.localidadSelect.value;
  }

  normalizar(texto) {
    return (texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2019']/g, '').toLowerCase();
  }

  mostrarTextoLibre() {
    this.addressCityInput.classList.remove('hidden');
    this.comunaWrapper.classList.add('hidden');
    if (this.localidadField) this.localidadField.classList.add('hidden');
    if (this.cityLabel) {
      this.cityLabel.textContent = this.cityField.dataset.labelCity;
      this.cityLabel.setAttribute('for', this.addressCityInput.id);
    }
  }

  // Shopify rotula la RM como "Santiago", que se confunde con la comuna: se cambia solo el texto
  // visible; el valor que viaja a la tarifa sigue siendo el de Shopify ("Santiago")
  renombrarRegionMetropolitana() {
    const etiqueta = this.cityField && this.cityField.dataset.labelRm;
    if (!etiqueta) return;
    Array.from(this.addressProvinceSelect.options).forEach((o) => {
      if (this.normalizar(o.value).indexOf('metropolitan') !== -1 || this.normalizar(o.text) === 'santiago') {
        o.text = etiqueta;
      }
    });
  }

  async syncCityField(reiniciar) {
    const esChile = this.normalizar(this.addressCountrySelect.value).indexOf('chile') !== -1;
    if (!esChile) {
      this.mostrarTextoLibre();
      return;
    }
    this.renombrarRegionMetropolitana();
    if (!this.regiones) {
      try {
        const respuesta = await fetch(this.cityField.dataset.comunasUrl);
        this.regiones = await respuesta.json();
      } catch (e) {
        // sin el listado se vuelve al campo de texto: la calculadora sigue funcionando
        this.mostrarTextoLibre();
        return;
      }
    }

    this.addressCityInput.classList.add('hidden');
    this.comunaWrapper.classList.remove('hidden');
    if (this.cityLabel) {
      this.cityLabel.textContent = this.cityField.dataset.labelComuna;
      this.cityLabel.setAttribute('for', this.comunaSelect.id);
    }

    const opcion = this.addressProvinceSelect.options[this.addressProvinceSelect.selectedIndex];
    const provincia = this.normalizar(this.addressProvinceSelect.value + ' ' + (opcion ? opcion.text : ''));
    const region = this.regiones.find((r) => r.claves.some((clave) => provincia.indexOf(clave) !== -1));
    let anterior = reiniciar ? '' : this.normalizar(this.addressCityInput.value);
    let localidadAnterior = '';
    this.regionActual = region;

    // si lo guardado es una localidad, se elige su comuna y despues la localidad
    if (region && anterior && !Array.isArray(region.localidades)) {
      Object.keys(region.localidades || {}).forEach((comuna) => {
        if (region.localidades[comuna].some((l) => this.normalizar(l) === anterior)) {
          localidadAnterior = anterior;
          anterior = this.normalizar(comuna);
        }
      });
    }

    this.comunaSelect.innerHTML = '';
    const primera = new Option(region ? this.cityField.dataset.placeholderComuna : this.cityField.dataset.placeholderRegion, '');
    primera.disabled = !region;
    this.comunaSelect.add(primera);
    if (region) {
      const lugares = region.comunas.concat(this.localidadesSinComuna(region))
        .sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
      lugares.forEach((comuna) => {
        const o = new Option(comuna, comuna);
        if (anterior && this.normalizar(comuna) === anterior) o.selected = true;
        this.comunaSelect.add(o);
      });
    }
    this.comunaSelect.disabled = !region;
    this.addressCityInput.value = this.comunaSelect.value;
    this.syncLocalidades(localidadAnterior);
  }

  comunaFaltante() {
    if (!this.comunaSelect || this.comunaWrapper.classList.contains('hidden') || this.comunaSelect.value) return false;
    this.comunaSelect.setAttribute('aria-invalid', 'true');
    this.comunaSelect.focus();
    this.resultsList.innerHTML = '';
    this.resultsSuccessHeading.classList.add('hidden');
    this.resultsErrorHeading.classList.remove('hidden');
    this.appendResultNode(this.cityField.dataset.requiredComuna);
    this.resultsTag.classList.remove('hidden');
    this.showingErrors = true;
    return true;
  }

  disconnectedCallback() {
    document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
    document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
  }

	setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(this.addressCountrySelect.id, this.addressProvinceSelect.id, {
        hideElement: 'AddressProvinceContainerCalculator'
      });
    }
  }

  onCartChange() {
    this.resultsTag.classList.add('hidden');
  }

  serialize(obj, prefix) {
	  var str = [], p;
	  for (p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      var k = prefix ? prefix + "[" + p + "]" : p,
	        v = obj[p];
	      str.push((v !== null && typeof v === "object") ?
	        this.serialize(v, k) :
	        encodeURIComponent(k) + "=" + encodeURIComponent(v));
	    }
	  }
	  return str.join("&");
	}

  startLoading() {
    this.needEndLoading = false;
    this.button.setAttribute('aria-disabled', true);
    this.button.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  endLoading() {
    if(this.needEndLoading) {
      // Run end loading action
      this.needEndLoading = false;
      this.button.setAttribute('aria-disabled', false);
      this.button.classList.remove('loading');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }
  }

  appendResultNode(text) {
    const li = document.createElement("li");
    const node = document.createTextNode(text);
    li.appendChild(node);
    this.resultsList.appendChild(li);
  }

  // Shopify responde {shipping_rates: [...]} cuando cotiza y, si algo falla, un objeto de
  // errores ({zip: ["..."]}, {error: "..."}), null o una excepcion de red
  mensajesDeError(errores) {
    if (!errores || typeof errores !== 'object' || errores instanceof Error) return [];
    const mensajes = [];
    Object.keys(errores).forEach((clave) => {
      [].concat(errores[clave]).forEach((mensaje) => {
        if (typeof mensaje === 'string' && mensaje) mensajes.push(mensaje);
      });
    });
    return mensajes;
  }

  // aviso sin encabezado de error ni de exito (15-09: carrito que no necesita despacho)
  mostrarAviso(texto) {
    this.resultsList.innerHTML = '';
    this.resultsErrorHeading.classList.add('hidden');
    this.resultsSuccessHeading.classList.add('hidden');
    this.appendResultNode(texto);
    this.resultsTag.classList.remove('hidden');
    this.showingErrors = true;
  }

  carritoSinDespacho() {
    return fetch(`${routes.cart_url}.js`)
      .then((respuesta) => respuesta.json())
      .then((carrito) => carrito.item_count > 0 && carrito.requires_shipping === false)
      .catch(() => false);
  }

  handleResultsList(list) {
    this.resultsList.innerHTML = '';
    // Antes de este chequeo (15-09) una respuesta de error hacia caer list.shipping_rates.length,
    // la caida se repetia dentro del catch y la calculadora no mostraba nada
    if (!list || !Array.isArray(list.shipping_rates)) {
      const mensajes = this.mensajesDeError(list);
      (mensajes.length ? mensajes : [this.dataset.genericError]).forEach((mensaje) => this.appendResultNode(mensaje));
      this.resultsTag.classList.remove('hidden');
      return;
    }
    if (list.shipping_rates.length == 0) {
      this.resultsSuccessHeading.classList.add("hidden");
      this.appendResultNode(this.dataset.doNotShipMessage);
      this.resultsTag.classList.remove("hidden");
      return;
    }
    for(var key in list) {
      if(Array.isArray(list[key])) {
        list[key].forEach((item) => {
          if(typeof item === 'object') {
            const li = document.createElement("li");
            const spanPrice = document.createElement("span");
            spanPrice.classList.add('price');
            const span = document.createElement("span");
            span.classList.add('cart-item__price', 'heading-font');
            const text = item.presentment_name + ': ';
            span.innerHTML = Shopify.showPrice(item.price * 100);
            spanPrice.append(span);
            const node = document.createTextNode(text);
            li.appendChild(node);
            li.appendChild(spanPrice);
            if(item.delivery_days.length > 0) {
              const spanDate = document.createElement("span");
              spanDate.classList.add('caption', 'shipping-calculator__date');
              var spanDateText = '( ';
              if(item.delivery_days[0] == item.delivery_days[1]) {
                if(parseInt(item.delivery_days[0]) <= 1) {
                  spanDateText += this.dataset.deliveryDateOne.replace('[count]', item.delivery_days[0]);
                } else {
                  spanDateText += this.dataset.deliveryDateMany.replace('[count]', item.delivery_days[0]);
                }
              } else {
                spanDateText += this.dataset.deliveryDateRange.replace('[minimum]', item.delivery_days[0]).replace('[maximum]', item.delivery_days[1]);
              }
              spanDateText += ' )';
              const nodeSpanDateText = document.createTextNode(spanDateText);
              spanDate.appendChild(nodeSpanDateText);
              li.appendChild(spanDate);
            }
            this.resultsList.appendChild(li);
          } else {
            this.appendResultNode(item);
          }
        });
      } else {
        this.appendResultNode(list[key]);
      }
    }
    this.resultsTag.classList.remove('hidden');
  }

  handleErrorResponse(errors) {
    this.generatedShipping = 0;
    this.showingErrors = true;
    this.resultsErrorHeading.classList.remove('hidden');
    this.resultsSuccessHeading.classList.add('hidden');
    this.handleResultsList(errors);
  }

  handleSuccessResponse(list) {
    this.generatedShipping = 0;
    this.showingErrors = false;
    this.resultsSuccessHeading.classList.remove('hidden');
    this.resultsErrorHeading.classList.add('hidden');
    this.handleResultsList(list);
  }

  hideErrorsTag() {
    if(this.showingErrors) {
      this.resultsTag.classList.add('hidden');
      this.showingErrors = false;
    }
  }

  onButtonClick(event) {
  	if (this.button.classList.contains('loading')) return;
    // en Chile no se cotiza sin comuna: es lo que evitaba "Antofagasta" + "Santiago"
    if (this.comunaFaltante()) return;

    this.startLoading();
    // Con productos que no se despachan (servicios, cobros de prueba) Shopify no cotiza:
    // se avisa eso en vez de pedir tarifas que no existen
    this.carritoSinDespacho().then((sinDespacho) => {
      if (!sinDespacho) return this.cotizar();
      this.needEndLoading = true;
      this.mostrarAviso(this.dataset.noShippingRequired);
      this.endLoading();
    });
  }

  cotizar() {
    const params = {
    	shipping_address: {
    		country: this.addressCountrySelect.value,
	    	province: this.addressProvinceSelect.value,
	    	// La ciudad la piden los transportistas chilenos para tarificar por
	    	// comuna. Se envia vacia si el campo no esta en el marcado.
	    	city: this.addressCityInput ? this.addressCityInput.value : '',
	    	zip: this.addressZipInput.value
    	}
    };

    const body = JSON.stringify(params);
    fetch(`${routes.cart_url}/prepare_shipping_rates.json`, {...fetchConfig('json', 'POST'), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      if(response == null || response.ok) {
        fetch(`${routes.cart_url}/async_shipping_rates.json?` + this.serialize(params), {...fetchConfig('json', 'GET'), ...{}})
        .then((finalResponse) => finalResponse.json())
        .then((finalResponse) => {
          if(finalResponse != null) {
            this.needEndLoading = true;
            this.handleSuccessResponse(finalResponse);
          } else if(this.generatedShipping < 10) {
            this.needEndLoading = false;
            setTimeout(() => {
              this.needEndLoading = true;
              this.endLoading();
              this.generatedShipping++;
              this.button.dispatchEvent(new MouseEvent('click'));
            }, 2300);
          } else {
            // 10 intentos sin tarifas: se avisa y se suelta el boton, que antes quedaba cargando
            this.generatedShipping = 0;
            this.needEndLoading = true;
            this.handleErrorResponse(null);
          }
        })
        .catch(() => {
          this.needEndLoading = true;
          this.handleErrorResponse(null);
        })
        .finally(() => {
          this.endLoading();
        });
      } else {
        this.needEndLoading = true;
        this.handleErrorResponse(response);
      }
    })
    .catch((e) => {
      this.needEndLoading = true;
      this.handleErrorResponse(e);
    })
    .finally(() => {
      this.endLoading();
    });
  }
}

customElements.define('shipping-calculator', ShippingCaculator);